function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Button = require("../Button");
var _Field = require("../Field");
var _styles = require("./styles");
var _utils = require("../../utils");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["step", "min", "max", "label", "description", "descriptionId", "disabled", "onChange", "value", "fieldStyle", "inputStyle", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var NumberInput = exports.NumberInput = (0, _react.memo)(function (_ref) {
  var _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    max = _ref.max,
    label = _ref.label,
    description = _ref.description,
    descriptionId = _ref.descriptionId,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    value = _ref.value,
    fieldStyle = _ref.fieldStyle,
    inputStyle = _ref.inputStyle,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _descriptionId = (0, _react.useMemo)(function () {
    return descriptionId || description ? (0, _utils.GenerateId)() : undefined;
  }, [descriptionId, description]);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isFocused = _useState2[0],
    _setIsFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(value.toString()),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _value = _useState4[0],
    _setValue = _useState4[1];
  var _validRegex = new RegExp(/^\d+$/g);
  var _validDecimalRegex = new RegExp(/^\d+(\.\d{0,2})?$/g);
  var _zeroRegex = new RegExp(/^0\d+$/g);
  var _hasMax = !!max;
  var _isIncreaseDisabled = _hasMax && value >= max || disabled;
  var _isDecreaseDisabled = value <= min || disabled;
  var _isDecimal = step % 1 !== 0;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _isPointerOverDecrease = _useState6[0],
    _setIsPointerOverDecrease = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    _isPointerOverIncrease = _useState8[0],
    _setIsPointerOverIncrease = _useState8[1];
  var _changeValue = function _changeValue(newValue) {
    var isButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (disabled) return;
    if (!isButton) {
      if (newValue === '') {
        newValue = '0';
      } else if (newValue === '.') {
        newValue = '0.';
      } else if (_zeroRegex.test(newValue)) {
        newValue = parseInt(newValue, 10).toString();
      } else if (!_isDecimal && !_validRegex.test(newValue)) {
        newValue = _value;
      } else if (_isDecimal && !_validDecimalRegex.test(newValue)) {
        newValue = _value;
      }
    }
    if (_hasMax && parseFloat(newValue) > max) {
      newValue = max.toString();
    }
    if (parseFloat(newValue) < min) {
      newValue = min.toString();
    }
    _setValue(newValue);
    onChange(parseFloat(newValue));
  };
  var _increaseValue = function _increaseValue() {
    if (_isIncreaseDisabled) return;
    var _valueNumeric = parseFloat(_value);
    var _newValue = _valueNumeric + step;
    var _newValueString = _newValue.toString();
    _changeValue(_newValueString, true);
  };
  var _decreaseValue = function _decreaseValue() {
    if (_isDecreaseDisabled) return;
    var _valueNumeric = parseFloat(_value);
    var _newValue = _valueNumeric - step;
    var _newValueString = _newValue.toString();
    _changeValue(_newValueString, true);
  };
  var _onFocus = function _onFocus() {
    _setIsFocused(true);
  };
  var _onBlur = function _onBlur() {
    _setIsFocused(false);
  };
  var _onPointerEnterDecrease = function _onPointerEnterDecrease() {
    !_isDecreaseDisabled && _setIsPointerOverDecrease(true);
  };
  var _onPointerLeaveDecrease = function _onPointerLeaveDecrease() {
    _setIsPointerOverDecrease(false);
  };
  var _onPointerEnterIncrease = function _onPointerEnterIncrease() {
    _setIsPointerOverIncrease(true);
  };
  var _onPointerLeaveIncrease = function _onPointerLeaveIncrease() {
    _setIsPointerOverIncrease(false);
  };
  (0, _react.useEffect)(function () {
    if (value.toString() !== _value) {
      _setValue(value.toString());
    }
  }, [value, _value]);
  return (0, _jsxRuntime.jsx)(_Field.Field, Object.assign({
    label: label,
    description: description,
    descriptionId: _descriptionId,
    style: fieldStyle
  }, props, {
    children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: [styles.container, style, _isFocused && styles.container_focused],
      testID: "NumberInput",
      children: [(0, _jsxRuntime.jsx)(_Button.Button, {
        type: _Button.ButtonType.blank,
        onPress: _decreaseValue,
        label: "".concat(t('numberInput:decrease'), ": ").concat(label),
        testID: "NumberInputDecrease",
        textStyle: [styles.buttonTextStyle, _isDecreaseDisabled && styles.buttonTextStyle_disabled, _isPointerOverDecrease && styles.buttonTextStyle_pointerOver],
        state: {
          disabled: _isDecreaseDisabled
        },
        nativeContainerStyle: styles.buttonNativeContainer,
        onPointerEnter: _onPointerEnterDecrease,
        onPointerLeave: _onPointerLeaveDecrease,
        children: "-"
      }), (0, _jsxRuntime.jsx)(_reactNative.TextInput, {
        testID: "NumberInputField",
        style: [styles.value, inputStyle],
        value: _value,
        keyboardType: "numeric",
        onChangeText: _changeValue,
        editable: !disabled,
        onFocus: _onFocus,
        onBlur: _onBlur,
        autoCorrect: false,
        accessibilityLabel: label,
        accessibilityHint: description,
        accessibilityState: {
          disabled: disabled
        },
        accessibilityValue: {
          min: min,
          max: max,
          now: value
        },
        accessibilityDescribedBy: _descriptionId,
        accessibilityDisabled: disabled
      }), (0, _jsxRuntime.jsx)(_Button.Button, {
        type: _Button.ButtonType.blank,
        onPress: _increaseValue,
        label: "".concat(t('numberInput:increase'), ": ").concat(label),
        testID: "NumberInputIncrease",
        textStyle: [styles.buttonTextStyle, _isIncreaseDisabled && styles.buttonTextStyle_disabled, _isPointerOverIncrease && styles.buttonTextStyle_pointerOver],
        state: {
          disabled: _isIncreaseDisabled
        },
        nativeContainerStyle: styles.buttonNativeContainer,
        onPointerEnter: _onPointerEnterIncrease,
        onPointerLeave: _onPointerLeaveIncrease,
        children: "+"
      })]
    })
  }));
});